import React from "react";
import { Helmet } from "react-helmet";

function SLA() {
  return (
    <>
      <Helmet>
        <title>Service Level Agreement (SLA) » ClubHosty</title>
        <link rel="canonical" href="https://www.clubhosty.com/sla" />
      </Helmet>
      <main id="main">
        <section className="breadcrumbs">
          <div className="container">
            <div>
              <h2>Service Level Agreement (SLA)</h2>
              <br />
              <center>
                <p>
                  ClubHosty is committed to providing reliable and high-quality
                  hosting services. This Service Level Agreement outlines our
                  commitment to uptime, support response times, and service
                  quality standards.
                </p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12 ">
                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Uptime Guarantee
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty guarantees 99.9% uptime for all shared hosting,
                    VPS, cloud, and dedicated server services. This guarantee
                    applies to network availability and server uptime.
                  </p>
                  <p className="m-15px-b">
                    Planned maintenance windows are excluded from uptime
                    calculations. We will notify customers at least 48 hours in
                    advance of any scheduled maintenance that may affect service
                    availability.
                  </p>
                  <p className="m-15px-b">
                    If we fail to meet the 99.9% uptime guarantee in any given
                    month, eligible customers may request service credits as
                    outlined in our compensation policy below.
                  </p>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Uptime
                    Calculation
                  </h3>
                  <p className="m-15px-b">
                    Uptime is calculated on a monthly basis using the following
                    formula:
                  </p>
                  <p className="m-15px-b">
                    <strong>
                      Uptime % = ((Total Minutes in Month - Downtime Minutes) /
                      Total Minutes in Month) × 100
                    </strong>
                  </p>
                  <p className="m-15px-b">
                    Downtime is measured from when our monitoring systems detect
                    an issue until the service is fully restored and accessible.
                  </p>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Exclusions from
                    SLA
                  </h3>
                  <p className="m-15px-b">
                    The following circumstances are excluded from our uptime
                    guarantee:
                  </p>
                  <ul className="m-15px-b">
                    <li>
                      Scheduled maintenance with advance notification (minimum 48
                      hours)
                    </li>
                    <li>
                      Downtime caused by factors outside ClubHosty's control,
                      including force majeure events, internet service provider
                      issues, or distributed denial-of-service (DDoS) attacks
                    </li>
                    <li>
                      Issues caused by customer's applications, scripts, or
                      configurations
                    </li>
                    <li>
                      Downtime resulting from customer's violation of Terms of
                      Service
                    </li>
                    <li>
                      Outages caused by third-party software or services not
                      under ClubHosty's control
                    </li>
                    <li>
                      DNS propagation delays or issues with customer's domain
                      registrar
                    </li>
                    <li>
                      Suspension or termination of services due to non-payment
                      or policy violations
                    </li>
                  </ul>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Support Response
                    Times
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty provides 24/7/365 technical support through
                    multiple channels including ticket system, live chat, and
                    email. Our response time commitments are:
                  </p>
                  <ul className="m-15px-b">
                    <li>
                      <strong>Critical Issues:</strong> Initial response within 1
                      hour - Issues affecting complete service unavailability or
                      critical security vulnerabilities
                    </li>
                    <li>
                      <strong>High Priority Issues:</strong> Initial response
                      within 4 hours - Significant performance degradation or
                      partial service unavailability
                    </li>
                    <li>
                      <strong>Medium Priority Issues:</strong> Initial response
                      within 12 hours - Minor functionality issues or performance
                      concerns
                    </li>
                    <li>
                      <strong>Low Priority Issues:</strong> Initial response
                      within 24 hours - General inquiries, feature requests, or
                      minor issues
                    </li>
                  </ul>
                  <p className="m-15px-b">
                    Response times are measured from the time a support ticket is
                    submitted or chat is initiated to the time our support team
                    provides an initial response.
                  </p>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Service Credits
                    and Compensation
                  </h3>
                  <p className="m-15px-b">
                    If ClubHosty fails to meet the guaranteed uptime in any
                    calendar month, eligible customers may request service
                    credits according to the following schedule:
                  </p>
                  <ul className="m-15px-b">
                    <li>
                      <strong>99.9% - 99.0% uptime:</strong> 5% credit of
                      monthly service fee
                    </li>
                    <li>
                      <strong>99.0% - 95.0% uptime:</strong> 10% credit of
                      monthly service fee
                    </li>
                    <li>
                      <strong>Below 95.0% uptime:</strong> 25% credit of monthly
                      service fee
                    </li>
                  </ul>
                  <p className="m-15px-b">
                    To request a service credit, customers must submit a support
                    ticket within 7 days of the end of the month in which the
                    downtime occurred. Credits will be applied to the customer's
                    account and can be used toward future services.
                  </p>
                  <p className="m-15px-b">
                    Service credits are the sole and exclusive remedy for any
                    failure to meet the SLA. The maximum credit in any month
                    shall not exceed 25% of the monthly service fee for the
                    affected service.
                  </p>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Performance
                    Standards
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty maintains the following performance standards:
                  </p>
                  <ul className="m-15px-b">
                    <li>
                      Regular server monitoring and proactive maintenance to
                      prevent issues
                    </li>
                    <li>
                      Redundant network connectivity and power systems for
                      critical infrastructure
                    </li>
                    <li>
                      Daily backups for shared hosting accounts (available upon
                      request)
                    </li>
                    <li>
                      Hardware replacement within 4 hours for critical component
                      failures
                    </li>
                    <li>
                      Security updates and patches applied within 48 hours of
                      availability for critical vulnerabilities
                    </li>
                  </ul>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Network and Data
                    Center Standards
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty operates from tier-3 and tier-4 data centers with:
                  </p>
                  <ul className="m-15px-b">
                    <li>Multiple redundant network carriers</li>
                    <li>N+1 redundancy for power and cooling systems</li>
                    <li>24/7 on-site security and monitoring</li>
                    <li>Fire suppression and environmental controls</li>
                    <li>DDoS protection and mitigation services</li>
                    <li>Direct fiber connections to major internet backbones</li>
                  </ul>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Customer
                    Responsibilities
                  </h3>
                  <p className="m-15px-b">
                    To maintain eligibility for SLA guarantees, customers must:
                  </p>
                  <ul className="m-15px-b">
                    <li>
                      Keep all account contact information current and accurate
                    </li>
                    <li>
                      Respond to support requests in a timely manner when
                      troubleshooting issues
                    </li>
                    <li>
                      Comply with ClubHosty's Terms of Service and acceptable use
                      policies
                    </li>
                    <li>
                      Maintain payment obligations and keep accounts in good
                      standing
                    </li>
                    <li>
                      Report issues promptly through official support channels
                    </li>
                    <li>
                      Follow best practices and recommendations provided by
                      ClubHosty support team
                    </li>
                  </ul>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Monitoring and
                    Reporting
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty uses advanced monitoring systems to track service
                    availability and performance. Customers can request uptime
                    reports for their services by submitting a support ticket.
                  </p>
                  <p className="m-15px-b">
                    We maintain detailed logs of all service incidents and
                    maintenance activities. These records are available to
                    customers upon request for verification of uptime statistics.
                  </p>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> SLA Modifications
                  </h3>
                  <p className="m-15px-b">
                    ClubHosty reserves the right to modify this Service Level
                    Agreement with 30 days' notice to customers. Changes will be
                    posted on our website and communicated via email to active
                    customers.
                  </p>
                  <p className="m-15px-b">
                    Continued use of ClubHosty services after the effective date
                    of SLA modifications constitutes acceptance of the updated
                    terms.
                  </p>
                </div>

                <div className="section-heading">
                  <h3 className="black-color p-5px-b">
                    <i className="fas fa-hand-point-right"></i> Contact
                    Information
                  </h3>
                  <p className="m-15px-b">
                    For questions about this Service Level Agreement or to report
                    service issues, please contact our support team:
                  </p>
                  <ul className="m-15px-b">
                    <li>Support Ticket System: Available 24/7 through client area</li>
                    <li>Live Chat: Available on our website</li>
                    <li>Email: support@clubhosty.com</li>
                  </ul>
                  <p className="m-15px-b">
                    <strong>Last Updated:</strong> October 2025
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default SLA;
